import { useEffect } from "react";
import { useHomeUsePluginContainer } from "./container";

type NodesRenderComplatedProps = {
  /**
   * 切换项目挂载成功后的事件
   * @returns
   */
  onProjectMounted?: () => void;

  /**
   * 每个节点渲染成功后的事件
   * @returns
   */
  onNodeUpdated?: () => void;
};

/**
 * 用于监听 HomeUsePlugin canvas 画布中的节点是否渲染完成
 *
 * 状态从 reactflow useNodesInitialized
 *
 * @param effect
 */
export function useNodesRenderComplated(props?: NodesRenderComplatedProps) {
  const { homeReactFlowState, showNavPageState } = useHomeUsePluginContainer();
  const [showNavPage] = showNavPageState;
  const { nodeProjectMounted, nodeRenderUpdated } = homeReactFlowState;

  // 对节点渲染进行监听
  useEffect(() => {
    const init = () => {
      if (nodeRenderUpdated) {
        const swtichProjectMouted = !showNavPage && nodeRenderUpdated;
        if (nodeProjectMounted.value !== swtichProjectMouted) {
          nodeProjectMounted.value = swtichProjectMouted;

          if (nodeProjectMounted.value) {
            // 项目切换挂载成功事件
            return props?.onProjectMounted?.();
          }
        }
      } else if (showNavPage) {
        nodeProjectMounted.value = false;
      }

      // 节点渲染成功
      if (nodeRenderUpdated) {
        return props?.onNodeUpdated?.();
      }
    };

    init();
  }, [nodeRenderUpdated]);
}
